











//
// WARNING
// This file is auto-generated by Commands.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Commands.tst.
//

import { Command } from "@signature/crs-client";
import { endpoint, CommandResult } from '@/modules/crs/crs';


    

    @Command('Automelec.Model-Automelec.Model.Commands.ProductionSite.CreateBeltCommand')
    
    export class CreateBeltCommand {
        constructor( productionSiteId: number, name: string ) {
            
                this.productionSiteId = productionSiteId;
            
                this.name = name;
            
        }

        
            public productionSiteId: number;
        
            public name: string;
        
    }

    export interface ICreateBeltCommand {
        
            productionSiteId: number;
        
            name: string;
        
    }

    export async function createBelt( command: CreateBeltCommand ): Promise<CommandResult<number>>
    export async function createBelt( { productionSiteId, name }: ICreateBeltCommand ): Promise<CommandResult<number>>
    export async function createBelt( model: any ): Promise<CommandResult<number>> {
        if(model == null) throw new Error("Command cannot be null.");

        var result: CommandResult<number>;

        if(model instanceof CreateBeltCommand) {
            result = await endpoint.send<CommandResult<number>>(model);
        }
        else {
            result = await endpoint.send<CommandResult<number>>( new CreateBeltCommand( model['productionSiteId'], model['name'] ) );
        }

        return result;
    }

    /**
    * Extraneous types
    */
    export namespace CreateBeltCommand.ExtraneousTypes {
        

        
    }

